<template>
  <div>
    <page-header
      left-side-class="col-xl-8"
      right-side-class="col-xl-4 d-flex align-items-end justify-content-end pb-2"
      :page="headerPage"
      :actions="headerActions"
    />
    <section-title
      has-line
      content="Cargar Material o Equipo"
      container-class="tag-badge-info-custom"
    />
    <validation-observer tag="form" ref="observer">
      <div class="bg-gray-9 px-4 py-3 rounded">
        <item-info
          v-model="model"
          :saloons="collections.saloons"
          :centers="collections.centers"
          @center="(val) => getMunicipalities(val?.id)"
        />
        <location-info
          class="mt-2"
          v-model="model"
          :centers="collections.centers"
          :municipalities="collections.municipalities"
          :schools="collections.schools"
          :locationTypes="collections.locationTypes"
          @center="(val) => getMunicipalities(val?.id)"
          @municipality="(val) => getSchools(val?.id)"
        />
      </div>
    </validation-observer>
  </div>
</template>

<script>
import PageHeader from 'PageHeader';
import SectionTitle from 'SectionTitle';
import ActionButton from 'ActionButton';

import ItemInfo from './components/ItemInfo';
import LocationInfo from './components/LocationInfo';

import alertMixin from '@/mixin/alert.mixin';

import inventoryCatalogService from '@/services/api/materialsAndEquipments.api';
import locationService from '@/services/api/location.api';

import LocationTypes from '@/utils/constants/inventory/inventoryOrderBookLocationTypes';

export default {
  name: 'ItemLoad',
  components: {
    ActionButton,
    PageHeader,
    SectionTitle,
    ItemInfo,
    LocationInfo,
  },
  mixins: [alertMixin],
  data() {
    return {
      model: {
        name: null,
        center: null,
        municipality: null,
        school: null,
        saloon: null,
        location: null,
        description: null,
        locationType: null,
      },
      collections: {
        saloons: [],
        centers: [],
        municipalities: [],
        schools: [],
        locationTypes: [
          LocationTypes.CSEE,
          LocationTypes.CENTER,
          LocationTypes.SCHOOL,
        ],
      },
      properties: [],
      material: {},
    };
  },
  computed: {
    catalogId() {
      return Number(this.$route.params.id);
    },
    academicYearId() {
      return this.currentAcademicYear().id;
    },
    headerPage() {
      return {
        icon: 'fas fa-book-open',
        title: 'Cargar Materiales/Equipos',
        routes: ['Inicio', 'PEI', 'Catálogo de Materiales/Equipos '],
      };
    },
    headerActions() {
      return [
        {
          text: 'Regresar',
          icon: 'fas fa-arrow-circle-left',
          variant: 'outline-success',
          click: () => this.$router.go(-1),
        },
        {
          text: 'Guardar',
          icon: 'fas fa-save',
          variant: 'success',
          click: () => this.save(),
        },
      ];
    },
    isLocationSchool() {
      return this.model?.locationType?.id === LocationTypes.SCHOOL.id;
    },
  },
  async mounted() {
    await this.initData();
  },
  methods: {
    async initData() {
      await this.getMaterial();
      await Promise.allSettled([this.getSaloon(), this.getCenters()]);
    },
    async getMaterial() {
      const { data } = await inventoryCatalogService.get(this.catalogId);
      this.material = data;
      this.model.name = data.name;
    },
    async getSaloon() {
      const { data } = await inventoryCatalogService.getSaloon();
      this.collections.saloons = data;
    },
    async getCenters() {
      const { data } = await locationService.getCenters({
        academicYearId: this.academicYearId,
      });
      this.collections.centers = data;
    },
    async getMunicipalities(centerId = null) {
      this.model.municipality = null;
      this.collections.municipalities = [];
      this.model.school = null;
      this.collections.schools = [];

      if (!centerId) return;
      if (!this.isLocationSchool) return;
      const sameCenter =
        this.collections.municipalities.length &&
        this.collections.municipalities.every((s) => s.centerId === centerId);

      if (sameCenter) return;

      const { data } = await locationService.getMunicipalities({
        academicYearId: this.academicYearId,
        centerId,
      });
      this.collections.municipalities = centerId
        ? data.map((x) => ({ ...x, centerId }))
        : data;
    },
    async getSchools(municipalityId = null) {
      this.model.school = null;
      this.collections.schools = [];

      if (!municipalityId) return;

      const sameMunicipality =
        this.collections.schools.length &&
        this.collections.schools.every(
          (s) => s.municipalityId === municipalityId
        );
      if (sameMunicipality) return;

      const { data } = await locationService.getSchools({
        academicYearId: this.academicYearId,
        municipalityId,
      });
      this.collections.schools = municipalityId
        ? data.map((x) => ({ ...x, municipalityId }))
        : data;
    },
    async save() {
      const valid = await this.$refs.observer.validate();
      if (!valid) return;

      const { center, saloon } = this.model;

      const locationTypeId = this.model?.locationType?.id;
      const hasCenter = locationTypeId > LocationTypes.CSEE.id;
      const payload = {
        name: this.model.name,
        quantity: Number(this.model.quantity),
        saloonTypeId: saloon?.id,
        centerId: hasCenter ? center?.id : null,
        address: this.model.location,
        description: this.model.description,
        catalogId: this.catalogId,
        schoolId: hasCenter ? this.model?.school?.id : null,
        locationTypeId,
      };

      const isConfirmed = await this.ShowCancelModal(
        'Atención',
        `¿Está seguro que desea guardar la información documentada al momento?`,
        'Si',
        'No'
      );
      if (isConfirmed) {
        try {
          await inventoryCatalogService.load(payload);
          this.$router.go(-1);
        } catch (error) {
          this.ShowToast('Error', error?.response?.data?.message, 'error');
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
